"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesEditSlippage = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
var GridV4FuturesEditSlippage;
(function (GridV4FuturesEditSlippage) {
    // 获取预计剩余开仓or平仓时间
    GridV4FuturesEditSlippage.getLeftTime = ({ order, orderBookData }) => {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const isSpot = order.orderType === TradeAPILib_1.ExchangeOrderType.gridV5;
        // 现货按照多仓处理
        const isLong = new trade_utils_lib_1.SafeDecimal(innerOrder.position).greaterThan(0) || isSpot;
        // 是否是关单计算
        const isCloseOrder = order.innerStatus === TradeAPILib_1.OrderInnerStatus.closePosition;
        // 预计剩余开仓时间（前端计算，获取一次当前盘口的挂单计算，无需实时变更）
        // 开多：剩余开仓数量/(卖1价至卖1价*(1+滑点设置值)的挂单数量)
        // 开空：剩余开仓数量/(买1价至买1价*(1-滑点设置值)的挂单数量)
        // 结果向上取整
        // 剩余关仓时间计算
        // 关单时撤掉所有挂单，并计算用户有多少待平仓位
        // 平多仓：假设用户设置的滑点为S，每秒吃单量=min{剩余平仓量，市价单单笔最大数量，该秒买一价至买一价*(1-S）的挂单总量}
        // 平空仓：假设用户设置的滑点为S，每秒吃单量=min{剩余平仓量，市价单单笔最大数量，该秒卖一价至卖一价*(1+S）的挂单总量}
        const slippage = isCloseOrder ? innerOrder.close_slippage : innerOrder.slippage;
        if (!orderBookData || !slippage)
            return "--";
        let odArr;
        let slippageV;
        if (isCloseOrder) {
            odArr = isLong ? orderBookData.bids : orderBookData.asks;
            slippageV = !isLong ? new trade_utils_lib_1.SafeDecimal(1).add(slippage) : new trade_utils_lib_1.SafeDecimal(1).sub(slippage);
        }
        else {
            odArr = isLong ? orderBookData.asks : orderBookData.bids;
            slippageV = isLong ? new trade_utils_lib_1.SafeDecimal(1).add(slippage) : new trade_utils_lib_1.SafeDecimal(1).sub(slippage);
        }
        const slippagePrice = new trade_utils_lib_1.SafeDecimal(innerOrder.latestPrice).mul(slippageV);
        let quantity = new trade_utils_lib_1.SafeDecimal(0);
        odArr.some((i) => {
            const vs = isLong ? slippagePrice.lessThanOrEqualTo(i.price) : slippagePrice.greaterThanOrEqualTo(i.price);
            if (vs) {
                quantity = quantity.add(i.quantity);
                return true;
            }
            else {
                return false;
            }
        });
        return new trade_utils_lib_1.SafeDecimal(isCloseOrder ? GridV4FuturesEditSlippage.getCommonLeftPosition(order) : GridV4FuturesEditSlippage.getCommonLeftAmount(order))
            .abs()
            .div(quantity.equals(0) ? odArr[0].quantity : quantity)
            .toDP(0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
            .toString();
    };
    // 获取剩余未开仓量
    GridV4FuturesEditSlippage.getLeftAmount = (order) => {
        return new trade_utils_lib_1.SafeDecimal(order.init_base_amount).sub(order.baseAmount).toFixed();
    };
    // 获取剩余未开仓量(通用)
    GridV4FuturesEditSlippage.getCommonLeftAmount = (order) => {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const value = new trade_utils_lib_1.SafeDecimal(innerOrder.init_base_amount).sub(innerOrder.baseAmount);
        return value.toFixed();
    };
    // 获取剩余未平仓量
    GridV4FuturesEditSlippage.getLeftPosition = (order) => {
        return new trade_utils_lib_1.SafeDecimal(order.position).toFixed();
    };
    // 获取剩余未平仓量(通用)
    GridV4FuturesEditSlippage.getCommonLeftPosition = (order) => {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const isSpot = order.orderType === TradeAPILib_1.ExchangeOrderType.gridV5;
        const value = isSpot ? new trade_utils_lib_1.SafeDecimal(innerOrder.baseAmount) : new trade_utils_lib_1.SafeDecimal(innerOrder.position);
        return value.toFixed();
    };
    /**
     * 修改ai滑点设置，支持开单和关单
     * slippage?: string; 开单时必传
     * close_slippage?: string; 关单时必传
     */
    GridV4FuturesEditSlippage.submit = ({ slippage, close_slippage, orderId, orderType, }) => {
        const data = {};
        if (slippage) {
            data.slippage = new trade_utils_lib_1.SafeDecimal(slippage).toString();
        }
        if (close_slippage) {
            data.close_slippage = new trade_utils_lib_1.SafeDecimal(close_slippage).toString();
        }
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/modify_slippage/`,
            data,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    /**
     * 获取ai推荐滑点
     * @param order
     * @returns
     */
    GridV4FuturesEditSlippage.getCloseOrderRecommendSlippage = (order) => {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const isSpot = order.orderType === TradeAPILib_1.ExchangeOrderType.gridV5;
        // 现货网格开单
        const isSpotOpen = isSpot && !order.id;
        // 只有现货网格有开单场景，合约网格都是关单时才会调用这个接口
        // 所以合约网格都以平仓情况处理side
        let side;
        if (isSpot) {
            side = isSpotOpen ? "BUY" : "SELL";
        }
        else {
            const isLongPosition = new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position).greaterThan(0);
            side = isLongPosition ? "SELL" : "BUY";
        }
        const data = {
            base: order.base,
            quote: order.quote,
            trend: new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position).greaterThan(0) || isSpotOpen ? TradeAPILib_1.GridFuturesTrend.long : TradeAPILib_1.GridFuturesTrend.short,
            side,
        };
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${order.orderType}/recommend_slippage/`,
            data,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    };
    /**
     * 获取ai推荐滑点hooks
     * @param order
     * @returns
     */
    GridV4FuturesEditSlippage.useCloseOrderRecommendSlippage = (order) => {
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [aiSlippage, setAiSlippage] = (0, react_1.useState)();
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            GridV4FuturesEditSlippage.getCloseOrderRecommendSlippage(order).subscribe({
                next(value) {
                    setLoading(false);
                    setAiSlippage(value.slippage);
                },
                error(err) {
                    setAiSlippage("0.001");
                    setLoading(false);
                    setErrorMsg(err);
                },
                complete() {
                    setLoading(false);
                },
            });
        }, [order.base, order.quote, order.orderType, order.id]);
        return { loading, aiSlippage, errorMsg };
    };
})(GridV4FuturesEditSlippage || (exports.GridV4FuturesEditSlippage = GridV4FuturesEditSlippage = {}));
